/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState, useContext } from "react";
import { containerContext } from "./injection";
import { propsChangesArray } from "../propsChangesArray/propsChangesArray";
import { isShallowEqual } from "../isShallowEqual/isShallowEqual";

export function useSingleton<T>(classType: new (...args: any) => T): T {
    const container = useContext(containerContext);
    return container.get(classType);
}

// eslint-disable-next-line react-compiler/react-compiler
export function useTransient<T>(
    classType: new (...args: any) => T,
    props?: Record<string, any>
): T {
    "use no memo";

    const container = useContext(containerContext);
    const [instance, setInstance] = useState(() =>
        container.createTransient(classType)
    );

    // create new class instance on props change
    // either props will always be object/arrary or be undefined, so in this case hooks + if statement is ok
    if (props) {
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isFirstCheck = useRef(true);
        const isFirst = isFirstCheck.current;
        isFirstCheck.current = false;

        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (isFirst) {
                return;
            }
            setInstance(container.createTransient(classType));
            // eslint-disable-next-line react-compiler/react-compiler
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, propsChangesArray(props));
    }

    return instance;
}

/** this is potential dangerous! - synchronously updating state during a render can lead to problems  */
export function unsafe_useImmediately(
    func: () => void,
    props?: Record<string, any>
): void {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const previousRef = useRef<Record<string, any> | undefined>(undefined);
    if (props === undefined || !isShallowEqual(props, previousRef.current)) {
        func();
        previousRef.current = props;
    }
}
